export default __webpack_public_path__ + "static/media/cohort-learning.bff34767.svg";